import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './OOSTag.style';

const OOSTag: React.FC<{
  isCompact?: boolean;
}> = ({ isCompact }) => {
  const { t } = useTranslation();

  return <S.OOSTag isCompact={isCompact}>{t('outOfStockLabel')}</S.OOSTag>;
};

export default OOSTag;
